import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import { sidebarStore } from "common-frontend-components";
import { sidebarStyle } from "../../../assets/styles/styles";
import { backgroundColor } from "../../../assets/styles/colors";
import { globalAppConfigStore } from "../../../stores/appConfig/globalAppConfigStore";
export const SidebarContainer = ({ children }) => {
    const isOpen = sidebarStore.useOpen();
    const config = globalAppConfigStore.useComponent('sidebar-background');
    return (_jsx(Drawer, { anchor: 'left', open: isOpen, onClose: sidebarStore.setOpenFalse, children: _jsx(Box, { sx: { width: 250, backgroundColor, height: '100%', overflow: 'hidden' }, role: "presentation", onClick: sidebarStore.setOpenFalse, onKeyDown: sidebarStore.setOpenFalse, children: _jsxs(Box, { sx: {
                    width: '100%',
                    background: (config?.params?.background || "").replace("$url", config?.url || ""),
                    height: '100%',
                }, children: [_jsx(Box, { sx: sidebarStyle, children: children }, void 0), _jsx(Divider, {}, void 0)] }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=SidebarContainer.js.map